import React from "react";
import { Button, Icon } from "react-onsenui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faPlus, faSync } from "@fortawesome/free-solid-svg-icons";

const Stage4Content = ({ claim, setUploadType, setDocName, setCameraModalVis, handleDocPreview, setPreviewDocModal, setFocusedExtraImageID, setShouldTriggerJointVerification }) => {
  return (
    <>
      {/* Header Section */}
      <div style={{ padding: "20px", backgroundColor: "#5C7232", color: "#fff" }}>
        <h2 style={{ fontSize: "26px", fontWeight: "600" }}>भौतिक सत्यापन</h2>
      </div>

      {/* Form 10 Section */}
      <div style={{ borderTop: "1px solid #fff", padding: "20px" }}>
        <h4 style={{ fontSize: "18px", fontWeight: "600" }}>भौतिक सत्यापन के लिए वन और राजस्व विभाग के अधिकारियों को सूचना की पावती (2.6) (संलग्न 5)</h4>

        <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
          <Button
            modifier="large"
            style={{ width: "40%", marginLeft: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
            onClick={() => {
              if (!Boolean(claim?.courtDocuments[9]?.title === "SDM_SUMMON_RESULT_10")) {
                setUploadType("MAIN_DOC");
                setDocName("SDM_SUMMON_RESULT_10");
                setCameraModalVis(true);
              } else {
                setPreviewDocModal(true);
                handleDocPreview(claim?.courtDocuments[9]?.storageUrl);
              }
            }}
          >
            {!Boolean(claim?.courtDocuments[9]?.title === "SDM_SUMMON_RESULT_10") ? (
              <>
                <Icon icon="md-camera" size={20} />
                {Boolean(
                  claim?.extraImageFormCountForSync &&
                    claim?.extraImageFormCountForSync["SDM_SUMMON_RESULT_10"] !== 0
                ) && (
                  <FontAwesomeIcon icon={faSync} size="lg" color="#fff" style={{ marginLeft: "10px" }} />
                )}
              </>
            ) : (
              "फोटो देखें"
            )}
          </Button>

          {Boolean(claim?.courtDocuments[9]?.title === "SDM_SUMMON_RESULT_10") && (
            <Button
              modifier="large"
              style={{ width: "40%", marginRight: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                setDocName("SDM_SUMMON_RESULT_10");
                setShouldTriggerJointVerification(true);
                setUploadType("MAIN_DOC");
                setCameraModalVis(true);
              }}
            >
              <FontAwesomeIcon icon={faCamera} size="lg" />
            </Button>
          )}
        </div>

        {claim?.courtDocuments[9]?.extraImages?.map((item, indd) => (
          <div key={`extra-image-${indd}`} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
            <Button
              modifier="large"
              style={{ width: "40%", marginLeft: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                if (!(claim?.courtDocuments.length && claim?.courtDocuments[9]?.title === "SDM_SUMMON_RESULT_10")) {
                  setDocName("SDM_SUMMON_RESULT_10");
                  setCameraModalVis(true);
                } else {
                  setPreviewDocModal(true);
                  handleDocPreview(item?.url);
                }
              }}
            >
              {!Boolean(claim?.courtDocuments[9]?.title === "SDM_SUMMON_RESULT_10") ? (
                <FontAwesomeIcon icon={faCamera} size="lg" />
              ) : (
                "फोटो देखें"
              )}
            </Button>

            {claim?.courtDocuments[9]?.title === "SDM_SUMMON_RESULT_10" && (
              <Button
                modifier="large"
                style={{ width: "40%", marginRight: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
                onClick={() => {
                  setDocName("SDM_SUMMON_RESULT_10");
                  setCameraModalVis(true);
                  setFocusedExtraImageID(indd + 1);
                  setUploadType("UPDATE_EXTRA_IMAGE");
                }}
              >
                <FontAwesomeIcon icon={faCamera} size="lg" />
              </Button>
            )}
          </div>
        ))}

        <div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
          {Boolean(
            claim?.courtDocuments[9]?.title === "SDM_SUMMON_RESULT_10" ||
              Boolean(
                claim?.extraImageFormCountForSync &&
                  claim?.extraImageFormCountForSync["SDM_SUMMON_RESULT_10"] !== 0
              )
          ) && (
            <Button
              modifier="large"
              style={{ width: "40%", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                setDocName("SDM_SUMMON_RESULT_10");
                setCameraModalVis(true);
                setUploadType("NEW_EXTRA_IMAGE");
              }}
            >
              <FontAwesomeIcon icon={faPlus} size="lg" />
            </Button>
          )}
        </div>
      </div>

      {/* Form 11 Section */}
      <div style={{ borderTop: "1px solid #fff", padding: "20px" }}>
        <h4 style={{ fontSize: "18px", fontWeight: "600" }}>भौतिक सत्यापन प्रतिवेदन (2.8) (संलग्न 7)</h4>

        <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
          <Button
            modifier="large"
            style={{ width: "40%", marginLeft: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
            onClick={() => {
              if (!Boolean(claim?.courtDocuments[10]?.title === "SDM_SUMMON_RESULT_11")) {
                setUploadType("MAIN_DOC");
                setDocName("SDM_SUMMON_RESULT_11");
                setCameraModalVis(true);
              } else {
                setPreviewDocModal(true);
                handleDocPreview(claim?.courtDocuments[10]?.storageUrl);
              }
            }}
          >
            {!Boolean(claim?.courtDocuments[10]?.title === "SDM_SUMMON_RESULT_11") ? (
              <>
                <Icon icon="md-camera" size={20} />
                {Boolean(
                  claim?.extraImageFormCountForSync &&
                    claim?.extraImageFormCountForSync["SDM_SUMMON_RESULT_11"] !== 0
                ) && (
                  <FontAwesomeIcon icon={faSync} size="lg" color="#fff" style={{ marginLeft: "10px" }} />
                )}
              </>
            ) : (
              "फोटो देखें"
            )}
          </Button>

          {Boolean(claim?.courtDocuments[10]?.title === "SDM_SUMMON_RESULT_11") && (
            <Button
              modifier="large"
              style={{ width: "40%", marginRight: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                setDocName("SDM_SUMMON_RESULT_11");
                setUploadType("MAIN_DOC");
                setCameraModalVis(true);
              }}
            >
              <FontAwesomeIcon icon={faCamera} size="lg" />
            </Button>
          )}
        </div>

        {claim?.courtDocuments[10]?.extraImages?.map((item, indd) => (
          <div key={`extra-image-${indd}`} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
            <Button
              modifier="large"
              style={{ width: "40%", marginLeft: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                if (!(claim?.courtDocuments.length && claim?.courtDocuments[10]?.title === "SDM_SUMMON_RESULT_11")) {
                  setDocName("SDM_SUMMON_RESULT_11");
                  setCameraModalVis(true);
                } else {
                  setPreviewDocModal(true);
                  handleDocPreview(item?.url);
                }
              }}
            >
              {!Boolean(claim?.courtDocuments[10]?.title === "SDM_SUMMON_RESULT_11") ? (
                <FontAwesomeIcon icon={faCamera} size="lg" />
              ) : (
                "फोटो देखें"
              )}
            </Button>

            {claim?.courtDocuments[10]?.title === "SDM_SUMMON_RESULT_11" && (
              <Button
                modifier="large"
                style={{ width: "40%", marginRight: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
                onClick={() => {
                  setDocName("SDM_SUMMON_RESULT_11");
                  setCameraModalVis(true);
                  setFocusedExtraImageID(indd + 1);
                  setUploadType("UPDATE_EXTRA_IMAGE");
                }}
              >
                <FontAwesomeIcon icon={faCamera} size="lg" />
              </Button>
            )}
          </div>
        ))}

        <div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
          {Boolean(
            claim?.courtDocuments[10]?.title === "SDM_SUMMON_RESULT_11" ||
              Boolean(
                claim?.extraImageFormCountForSync &&
                  claim?.extraImageFormCountForSync["SDM_SUMMON_RESULT_11"] !== 0
              )
          ) && (
            <Button
              modifier="large"
              style={{ width: "40%", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                setDocName("SDM_SUMMON_RESULT_11");
                setCameraModalVis(true);
                setUploadType("NEW_EXTRA_IMAGE");
              }}
            >
              <FontAwesomeIcon icon={faPlus} size="lg" />
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default Stage4Content;
